import React, { useCallback } from 'react';
import { setDeviceSettingsKey } from 'actions/deviceSettings';
import IconThreeUser from 'design-system/icons/IconThreeUser';
import FeatureCard from 'features/feed/components/FeatureCard';
import { useAddGroupModal } from 'features/group/hooks/useAddGroupModal';
import { useAppDispatch, useAppSelector } from 'store/hooks';
const strings = {
    title: 'Travelling together?',
    description: 'Create a group in Emma to split, track, and settle payments effortlessly',
    okButton: 'Create a group',
};
const THREE_MONTHS_MS = 1000 * 3600 * 24 * 90;
export const CreateGroupCard = () => {
    const dispatch = useAppDispatch();
    const lastTimeDismissCreateGroup = useAppSelector((store) => store.deviceSettings.lastTimeDismissCreateGroup);
    const { onCreateGroup: createGroup } = useAddGroupModal();
    const dismissCard = useCallback(() => {
        dispatch(setDeviceSettingsKey('lastTimeDismissCreateGroup', Date.now()));
    }, [dispatch]);
    const recentlyDismissed = lastTimeDismissCreateGroup !== undefined &&
        Date.now() - lastTimeDismissCreateGroup < THREE_MONTHS_MS;
    return (<FeatureCard cta={strings.okButton} title={strings.title} description={strings.description} image={<IconThreeUser colorKey={'brand'}/>} isCollapsed={recentlyDismissed} onPressCta={createGroup} onPressCancel={dismissCard}/>);
};
